<template>
  <div>
    <AIAssistantChatWindow v-model="isOpen" />

    <button
      class="ai-assistant-tab"
      :class="{ 'ai-assistant-tab--open': isOpen }"
      @click="toggleAssistant"
    >
      <v-icon small :color="isOpen ? 'white' : 'white'">
        {{ isOpen ? 'mdi-close' : 'mdi-robot' }}
      </v-icon>
      <span class="ai-assistant-tab__label">Qai</span>
    </button>
  </div>
</template>

<script>
import AIAssistantChatWindow from './AIAssistantChatWindow.vue';

export default {
  name: 'AIAssistantButton',
  components: {
    AIAssistantChatWindow
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleAssistant() {
      this.isOpen = !this.isOpen;
      this.$emit('toggle', this.isOpen);
    }
  }
};
</script>

<style scoped>
.ai-assistant-tab {
  position: fixed;
  right: 0;
  top: calc(90% - 38px); /* Adjust to position the button vertically */
  transform: translateY(-10%) translateX(0);
  z-index: 1000;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  width: 28px;
  padding: 12px 4px;
  border: none;
  border-radius: 6px 0 0 6px;
  background-color: var(--v-primary-base, #1976d2);
  color: white;
  cursor: pointer;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.25s ease, background-color 0.2s ease, width 0.25s ease;
}

.ai-assistant-tab:hover {
  transform: translateY(0%) translateX(2px);
  width: 32px;
  box-shadow: -3px 0 12px rgba(0, 0, 0, 0.3);
}

.ai-assistant-tab--open {
  background-color: #e53935;
}

.ai-assistant-tab--open:hover {
  background-color: #c62828;
}

.ai-assistant-tab__label {
  writing-mode: vertical-lr;
  text-orientation: mixed;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  user-select: none;
}

</style>
